import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
export const fetchObjectLabels = async () => {
  const results = await getFrameworkDataSchemasClient().then(client => client.frameworkTypes.getObjects());
  const companyMetadata = results.find(object => object.name === 'COMPANY');
  const contactMetadata = results.find(object => object.name === 'CONTACT');
  return {
    companyLabels: {
      plural: companyMetadata === null || companyMetadata === void 0 ? void 0 : companyMetadata.pluralForm,
      singular: companyMetadata === null || companyMetadata === void 0 ? void 0 : companyMetadata.singularForm
    },
    contactLabels: {
      plural: contactMetadata === null || contactMetadata === void 0 ? void 0 : contactMetadata.pluralForm,
      singular: contactMetadata === null || contactMetadata === void 0 ? void 0 : contactMetadata.singularForm
    }
  };
};